import { Box } from '@fairfashion/design-system'

import { NewItem } from '../../../../components/NewItem/new-item.comp'
import { ItemType } from '../../../../sdk/common/item-type.enum'
import { CreateSingleItemDTO } from '../../../../sdk/items/items.types'
import { sdk } from '../../../../services/sdk'
import { OriginItem } from '../../../OriginItems/origin-items.types'

import { CreateProductTraceabilityModalProps } from './create-product-traceability-modal.types'

export const CreateProductTraceabilityModal = ({
  open,
  itemCode,
  onClose,
  onCreated,
}: CreateProductTraceabilityModalProps) => {
  const onSubmit = async (data: OriginItem) => {
    const body = {
      code: data.code,
      description: data.description,
      itemProviderRelation: {
        companyProviderEmail:
          data.itemProviderRelation?.companyProviderEmail || '',
        companyProviderTaxId:
          data.itemProviderRelation?.companyProviderTaxId || '',
      },
      quantity: Number(data.quantity),
      taxUnit: data.taxUnit,
      metadata: data.metadata,
      type: ItemType.FINISHED,
      evidence: data.evidence?.files?.length ? data.evidence : undefined,
    } as CreateSingleItemDTO

    if (
      data.itemInvoice?.invoiceCode ||
      data.itemInvoice?.invoiceCreateDate ||
      data.itemInvoice?.invoiceKey ||
      data.itemInvoice?.invoiceFile
    ) {
      body.itemInvoice = {
        invoiceCode: data.itemInvoice?.invoiceCode || '',
        file: data.itemInvoice?.invoiceFile,
        invoiceAccessKey: data.itemInvoice?.invoiceKey,
        invoiceCreateDate: data.itemInvoice?.invoiceCreateDate
          ? new Date(data.itemInvoice?.invoiceCreateDate)
          : undefined,
      }
    }

    await sdk.items.createItem(body)

    onCreated?.()
    onClose?.()
  }

  return (
    <Box width="100%">
      {open && (
        <NewItem onSubmit={onSubmit} onCancel={onClose} itemCode={itemCode} />
      )}
    </Box>
  )
}
